import * as z from "zod";
import { mutator } from "./mutator";

export const testAuditLogDestinationSchema = z.object({
  id: z.string(),
});

export const testAuditLogDestination = mutator({
  schema: testAuditLogDestinationSchema,
  resolve: {
    destination: { kind: "auditLogDestination", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:audit_logs_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { destination } }) => {
    await tx.mutate.auditLogDestinations.update({
      id: destination.id,
      lastError: null,
      testingStartedAt: Date.now(),
    });
  },
});
